import React, { ReactElement } from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  LocalizationProvider,
  renderTimeViewClock,
  TimePicker,
} from '@mui/x-date-pickers';

export const TimeEditCell = ({
  props,
  schema,
}: {
  props: any;
  schema: any;
}): ReactElement => {
  const def = props.value ? dayjs(props.value, 'HH:mm') : null;

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          ampm={false}
          defaultValue={def}
          views={['hours', 'minutes']}
          onChange={(newValue: any) => {
            props.api.setEditCellValue({
              id: props.id,
              field: props.field,
              value:
                newValue === null
                  ? null
                  : dayjs(newValue, 'HH:mm').format('HH:mm'),
            });
          }}
          onClose={() => {
            /*apiRef.current.stopCellEditMode({
              id: params.id,
              field: params.field,
            });*/
          }}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
        />
      </LocalizationProvider>
    </>
  );
};
